import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sainsburys-tech/bolt';
import { ChevronIcon } from '@sainsburys-tech/bolt-icons';
import OpeningHours from '../OpeningHours/OpeningHours';
import ClickAndCollect from '../ClickAndCollect/ClickAndCollect';
import StoreMap from '../StoreMap/StoreMap';
import * as Styled from './StoreDetails.styles';
var aoSaveParam = '-ss:ss-cc';

var StoreDetails = function StoreDetails(_ref) {
  var store = _ref.store,
      distance = _ref.distance,
      toggleActiveStore = _ref.toggleActiveStore,
      selectStoreCallback = _ref.selectStoreCallback,
      mapsKey = _ref.mapsKey;
  var hideButtonEl = useRef(null);
  useEffect(function () {
    if (store !== null) {
      hideButtonEl.current.focus();
    }
  }, [store]);
  return /*#__PURE__*/React.createElement(Styled.StoreDetailsContainer, {
    store: store,
    clickandcollect: store && store.clickandcollect
  }, store !== null && /*#__PURE__*/React.createElement(Styled.HideButton, {
    ref: hideButtonEl,
    onClick: function onClick(event) {
      return toggleActiveStore(event, store, false);
    },
    "data-test": "toggle Chevron"
  }, "Hide", /*#__PURE__*/React.createElement(ChevronIcon, {
    width: 16,
    height: 12
  })), mapsKey && /*#__PURE__*/React.createElement(StoreMap, {
    store: store,
    showErrorMsg: true,
    mapsKey: mapsKey
  }), store && /*#__PURE__*/React.createElement(Styled.StoreContent, {
    "data-test": "component-store-selector-store-details"
  }, /*#__PURE__*/React.createElement("h2", null, store.name), /*#__PURE__*/React.createElement(Styled.StoreDistance, null, distance, " miles"), store.alert && /*#__PURE__*/React.createElement(Styled.StoreAlert, {
    kind: "error",
    isCloseable: false,
    "data-test": "component-store-selector-alert"
  }, store.alert), store.clickandcollect && /*#__PURE__*/React.createElement(ClickAndCollect, null), /*#__PURE__*/React.createElement(Styled.StoreRow, {
    className: "xs-row row"
  }, /*#__PURE__*/React.createElement(Styled.StoreDivider, null), /*#__PURE__*/React.createElement("div", {
    className: "xs-6"
  }, /*#__PURE__*/React.createElement(Styled.StoreInfo, null, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Address: "), store.location.address, ", ", store.location.postcode), store.contact !== '111111' && /*#__PURE__*/React.createElement(Styled.StoreInfo, null, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Telephone: "), /*#__PURE__*/React.createElement(Styled.StoreInfoTitle, {
    "aria-hidden": "true"
  }, "Tel."), " ", store.contact), /*#__PURE__*/React.createElement(Styled.StoreInfo, null, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Store Number: "), /*#__PURE__*/React.createElement(Styled.StoreInfoTitle, {
    "aria-hidden": "true"
  }, "Store no."), " ", store.id), store.clickAndCollectLocation && /*#__PURE__*/React.createElement(Styled.StoreInfo, null, /*#__PURE__*/React.createElement(Styled.StoreInfoTitle, {
    "aria-hidden": "true"
  }, "Collection point"), /*#__PURE__*/React.createElement(Styled.StoreCollectionPointText, {
    "data-test": "collection location"
  }, store.clickAndCollectLocation))), /*#__PURE__*/React.createElement("div", {
    className: "xs-6"
  }, /*#__PURE__*/React.createElement(OpeningHours, {
    hours: store.times
  }))), /*#__PURE__*/React.createElement(Styled.StoreActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick(event) {
      return selectStoreCallback(event, store, false, null, 'storeDetails', aoSaveParam);
    },
    "data-test": "select store",
    full: true
  }, "Select This Store"))));
};

StoreDetails.propTypes = {
  distance: PropTypes.number,
  selectStoreCallback: PropTypes.func,
  store: PropTypes.object,
  toggleActiveStore: PropTypes.func,
  mapsKey: PropTypes.string
};
StoreDetails.defaultProps = {
  distance: 0.1,
  store: null
};
export default StoreDetails;